import {authHeader} from "../../helpers/authHeader";
import axios from 'axios';


export default {
    login,
    logout,
    reload,
    refreshToken
};


function login(email, password) {
    const requestOptions = {
        headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'},

    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/login', {email, password}, requestOptions)

        .then(response => {
            const user = response.data;
            // login successful if there's a jwt token in the response
            if (user && user.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.data));
            }

            return user;
        }, handleError);
}

function reload() {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+'/api/user', requestOptions)

        .then(response => {
            const user = response.data;
            // login successful if there's a jwt token in the response
            if (user && user.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.data));
            }

            return user;
        }, handleError);
}

function refreshToken() {
    const requestOptions = {
        headers: Object.assign(authHeader(),{'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'}),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/refresh',{}, requestOptions)

        .then(response => {
            const user = response.data;
            // login successful if there's a jwt token in the response
            if (user && user.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.data));
            }

            return user;
        }, handleError);
}


function logout() {

    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+'/api/logout', {}, requestOptions)
        .then(()=>{localStorage.removeItem('user');},()=>{localStorage.removeItem('user');})

}




function handleError(error) {

    if (error.response && !(error.response.status >= 200 && error.response.status < 300)) {
        return Promise.reject(error.response.status);
    }

    return Promise.reject(500);

}



// WEBPACK FOOTER //
// ./src/data/user/api.js